/* eslint-disable default-case */
import { admin } from '../constants';
import produce from 'immer';

const adminInitialState = {
  error: '',
  isUserListFetching: false,
  isUserListFetchingFinished: false,
  isUserInfoUpdating: false,
  isUserInfoUpdatingFinished: false,
  users: []
};

const adminReducer = produce((draft, action) => {
  switch (action.type) {
    case admin.FETCH_USER_LIST_REQUEST: {
      draft.error = '';
      draft.isUserListFetching = true;

      return;
    }
    case admin.FETCH_USER_LIST_SUCCESS: {
      draft.users = action.users;
      draft.isUserListFetching = false;
      draft.isUserListFetchingFinished = true;

      return;
    }
    case admin.FETCH_USER_LIST_FAILED: {
      draft.error = action.error;
      draft.isUserListFetching = false;
      draft.isUserListFetchingFinished = true;

      return;
    }
    case admin.FETCH_USER_LIST_STATUS_RESET: {
      draft.isUserListFetchingFinished = false;

      return;
    }
    case admin.UPDATE_USER_INFO_REQUEST: {
      draft.error = '';
      draft.isUserInfoUpdating = true;

      return;
    }
    case admin.UPDATE_USER_INFO_SUCCESS: {
      draft.users = action.users;
      draft.isUserInfoUpdating = false;
      draft.isUserInfoUpdatingFinished = true;

      return;
    }
    case admin.UPDATE_USER_INFO_FAILED: {
      draft.error = action.error;
      draft.isUserInfoUpdating = false;
      draft.isUserInfoUpdatingFinished = true;

      return;
    }
    case admin.UPDATE_USER_INFO_STATUS_RESET: {
      draft.isUserInfoUpdatingFinished = false;

      return;
    }
  }
}, adminInitialState);

export default adminReducer;
